import React from 'react';
import { LinearProgress, makeStyles } from '@material-ui/core';

const useStyles = makeStyles({
    root: {
        padding: "1rem 2rem",
        borderRadius: "1rem",
        transition: "0.25s ease-in-out",
        maxWidth: "420px",
        "&.hidden": {
            display: "none",
        },
        "&.success": {
            backgroundColor: "#E0F3EE",
            color: "#1ECB79"
        },
        "&.error": {
            backgroundColor: "#F5E7EC",
            color: "#F65164"
        },
        "&.active": {
            backgroundColor: "#E3F2FF",
            color: "#1D8BF7"
        },
    },
    bodyWrapper: {
        display: "flex",
        alignItems: "center"
    },
    textWrapper: {
        marginLeft: "1.2rem",
    },
    title: {
        fontWeight: 600,
        fontSize: "0.9rem",
        margin: "0",
        padding: "0.25rem",
    },
    description: {
        margin: "0",
        padding: "0.25rem",
        fontSize: "0.9rem"
    },
    progressWrapper: {
        padding: "0.25rem",
        marginTop: "0.25rem"
    },
    barColour: {
        "&.success": {
            backgroundColor: "#1ECB79",
        },
        "&.active": {
            backgroundColor: "#1D8BF7",
        },
        "&.error": {
            backgroundColor: "#F5E7EC",
        },
    },
    barColourSecondary: {
        "&.success": {
            backgroundColor: "#1ECB79",
        },
        "&.active": {
            backgroundColor: "#f0f6fb",
        },
        "&.error": {
            backgroundColor: "#fbf4f6",
        },
    }
})
export interface ICurrentStatus {
    isActive: boolean;
    isDeterminate: boolean;
    percentComplete: number;
    progress: string;
    icon: React.ReactNode;
    title: string;
    description: string;
}

const CurrentStatus = (props: ICurrentStatus) => {
    const classes = useStyles();
    return (
        <div className={`${classes.root} ${props.progress}`}>
            <div className={classes.bodyWrapper}>
                {props.icon}
                <div className={classes.textWrapper}>
                    <h4 className={classes.title}>{props.title}</h4>
                    <div className={classes.description}>{props.description}</div>
                </div>
                
            </div>
            <div className={classes.progressWrapper}> 
                <LinearProgress 
                    variant={props.isDeterminate ? 'determinate' : 'indeterminate'} 
                    value={props.percentComplete}
                    classes={{
                        barColorPrimary: `${classes.barColour} ${props.progress}`, 
                        colorPrimary: `${classes.barColourSecondary} ${props.progress}`,
                    }}
                />
            </div>
        </div>
    )
}

export default CurrentStatus;
